import React, { useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";

/**
 * 
 * @param {props} id number for identifying 
 * @param {props} desc string display string
 * @param {props} remove function to remove this hover
 * 
 * @returns bootstrap Badge
 */
const HoverBadge = ({id, desc, remove, bg="energo", color="white"}) => {

    const [hover, setHover] = useState(false);

    return (
        <Badge
            onClick={() => remove(id)}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            key={id}
            id={`badge-${id}`}
            style={{marginRight: "5px", cursor: "pointer", maxWidth: "100%", display: "inline-block", color: color}}
            bg={bg}
            className="animate-slide-left"
            >
                <div className="d-flex" style={{maxWidth: "100%", overflow: "hidden", whiteSpace: "nowrap"}}>
                    <span style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        maxWidth: "100%"
                    }}>
                        {desc}
                    </span> 
                    {hover && <span className="text-danger" style={{marginLeft: 10}} bg="white">X</span>}
                </div>

            </Badge>
    )
}

export default HoverBadge;